import React, { useEffect } from 'react';
import Helmet from 'react-helmet';

//LPL's Google Floodlight tags on homepage- please do not remove
const LPLHomePageTagManagerPixel = () => {
  useEffect(() => {
    let attempts = 0;
    const maxAttempts = 30; // 30 * 100ms = 3 seconds

    const interval = setInterval(() => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', {
          allow_custom_scripts: true,
          send_to: 'DC-14818909/homep0/commo0+unique',
        });
        clearInterval(interval);
      }
      // Prevent infinite loop if window.gtag is not found
      if (++attempts >= maxAttempts) {
        console.warn('LPL gtag not found after 3 seconds — skipping conversion tag');
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <Helmet>
      <noscript>{`
    <img
      src="https://ad.doubleclick.net/ddm/activity/src=14818909;type=homep0;cat=commo0;ord=1?"
      width="1"
      height="1"
      alt=""
    />
  `}</noscript>
    </Helmet>
  );
};

export default LPLHomePageTagManagerPixel;
